import React, { Component } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import TinyPopover from 'react-tiny-popover'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import Expand from '../icons/Expand'
import Text from '../Text/Text'
import { SCREEN_SIZE, Media } from '../../lib/Media'
import Popup from '../Popup/Popup'
import { withRouter } from 'next/router'
import { SORT_DEFAULT_VALUES } from '../../lib/eventTrackerFunction'
import { disablePageScroll } from '../../lib/utils'
import SvgSort from '../icons/Sort'

const DEFAULT_SORT = 'RELEVANCE'

const GlobalPopoverStyle = createGlobalStyle`
  .sort-popover {
    z-index: 100000000;
    opacity: 1 !important;
  }
`

const InlineBlock = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;
`

const PlainContainer = styled.div`
  min-width: 10.5rem;
  justify-content: space-between;
  align-items: center;

  ${SCREEN_SIZE.From.Tablet} {
    max-width: 13.75rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    max-width: 15.5rem;
    height: auto;
    border: none;
    background-color: #ffffff;
    border: 1px solid #eaeaea;
  }
`
const SortContainer = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 10.5rem;

  ${SCREEN_SIZE.From.Desktop} {
    min-width: 10.5rem;
  }
`

const Block = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`
const Heading = styled.p`
  letter-spacing: 0.0625rem;
  color: #696969;
`
const SelectedFilter = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const StyledPopover = styled.div`
  display: flex;
  min-width: 13.625rem;
  border: 1px solid #eaeaea;
  background-color: white !important;
  box-shadow: 0 0.8125rem 0.9375rem 0 rgba(0, 0, 0, 0.12);
  ${SCREEN_SIZE.From.Desktop} {
    margin-left: -0.4rem;
  }
`
const StyledButton = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: left;

  /* IE11 */
  border: none;
  background: none;
  /* end IE11 */

  background-color: #ffffff;

  :focus {
    outline: none;
  }
`

const ListContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0.5rem 0.1rem;
  ${SCREEN_SIZE.Only.Mobile} {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

const Anchor = styled.div`
  display: flex;
  flex: 1;
  padding: 0.5rem 0.25rem;
  color: ${defaultTheme.ColorBaseBrandPrimary500};
  :hover {
    cursor: pointer;
    font-weight: bold;
  }
  ${SCREEN_SIZE.Below.Tablet} {
    padding: 0.875rem 0.5rem;
  }
`
const CheckBoxDiv = styled.div`
  width: 0.8rem;
  padding-right: 0.25rem;
`

const ButtonFullWidth = styled.div`
  width: 100%;

  /* IE11 */
  border: none;
  background: none;
  /* end IE11 */

  :focus {
    outline: none;
  }
`

const MobileSort = styled.div`
  display: none;
  ${SCREEN_SIZE.Below.MobileL} {
    display: flex;
  }
`

const ListContainerMobile = styled(ListContainer)`
  background: white;
  width: 100%;
  bottom: 0px;
  padding: 1.5rem 0 2.125rem 0.75rem;
  position: absolute;
  left: 0;
  border-radius: 0.25rem 0.25rem 0 0;
`
const HeadingMobile = styled(Heading)`
  padding: 0 0 0.875rem 1.25rem;
  color: #333333;
  letter-spacing: 0;
`
const TabletSort = styled.div`
  display: none;
  ${SCREEN_SIZE.Only.Tablet} {
    display: inline-block;
  }
`
const DesktopSort = styled.div`
  display: none;
  ${SCREEN_SIZE.From.Desktop} {
    display: block;
  }
`

const ListContainerDesktop = styled(ListContainer)`
  background: white;
  padding: 0 0.5rem;
  height: 15.5rem;
`

const ExpandStyled = styled(Expand)`
  transform: ${props => props.rotated && `rotate(-0.5turn)`};
  transition: transform 0.5s;
`

const TickIcon = styled.div`
  display: inline-block;
  padding: ${props => (props.mobile ? '0 0.125rem 0 0.125rem' : '0')};
  &:after {
    /*Add another block-level blank space*/
    content: '';
    display: block;

    /*Make it a small rectangle so the border will create an L-shape*/
    width: 3px;
    height: 6px;

    /*Add a white border on the bottom and left, creating that 'L' */
    border: solid #1557bf;
    border-width: 0 2px 2px 0;

    /*Rotate the L 45 degrees to turn it into a checkmark*/
    transform: rotate(45deg);
  }
`
const StyledSort = styled(SvgSort)`
  margin-right: 0.25rem;
  width: 1rem;
  height: 1rem;
`

const SortContent = styled.div`
  display: flex;
  padding: 0.5rem 1rem;
  border: 1px solid #1454b8;
  border-radius: 3.125rem;
  height: 2.25rem;
  background-color: ${({ isSort }) => (isSort ? '#e8f0fd' : 'white')};
  border-color: ${({ isSort }) => (isSort ? '#1454B8' : '#cccccc')};
  align-items: center;
  justify-content: center;
  &:active {
    background-color: #e8f0fd;
    border: 2px solid #1454b8;
  }
`

class Sort extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupOpen: false,
      dropdownOpen: false,
    }
    this.handlePopup = this.handlePopup.bind(this)
    this.handleSelection = this.handleSelection.bind(this)
  }

  componentDidUpdate() {
    disablePageScroll(this.state.popupOpen)
  }

  handlePopup(bool) {
    this.setState({
      popupOpen: bool,
      dropdownOpen: bool,
    })
  }

  handleSelection(input, label) {
    this.handlePopup(false)
    this.setState({ isVisiblePopover: false })

    if (this.props.onHandleSort) {
      this.props.onHandleSort(input, label)
    }
  }

  render() {
    const { isVisiblePopover } = this.state
    let selectedType = this.props.router?.query?.sorting || DEFAULT_SORT
    const isSortingEnabled =
      (this.props.router?.query?.sorting &&
        this.props.router?.query?.sorting !== 'POPULARITY') ||
      ''

    const data = this.props.data || SORT_DEFAULT_VALUES

    if (!data.find(ele => ele.slug === selectedType)) {
      selectedType = DEFAULT_SORT
    }

    const openPopover = () => this.setState({ isVisiblePopover: true })
    const closePopover = () => this.setState({ isVisiblePopover: false })

    return (
      <PlainContainer>
        <GlobalPopoverStyle />
        <Media query={SCREEN_SIZE.Below.Tablet}>
          <MobileSort onClick={() => this.handlePopup(true)}>
            <SortContent
              data-testid="expandSortMobile"
              isSort={isSortingEnabled}
            >
              <Block>
                <StyledSort
                  color={
                    isSortingEnabled
                      ? '#1454B8'
                      : defaultTheme.ColorBaseMineShaft700
                  }
                />
              </Block>
              <Block>
                <SelectedFilter>
                  <Text
                    size="medium"
                    color={
                      isSortingEnabled
                        ? '#1454B8'
                        : defaultTheme.ColorBaseMineShaft700
                    }
                    weight="bold"
                  >
                    {isSortingEnabled
                      ? data.filter(elm => elm.slug === selectedType)[0]
                          .displayName
                      : 'Sort'}
                  </Text>
                </SelectedFilter>
              </Block>
            </SortContent>
            {this.state.popupOpen && (
              <Popup onClose={() => this.handlePopup(false)}>
                <ListContainerMobile>
                  <HeadingMobile>
                    <Text
                      size="xl"
                      weight="bold"
                      color={defaultTheme.ColorBaseMineShaft700}
                    >
                      Sort by
                    </Text>
                  </HeadingMobile>
                  {data.map(e => (
                    <Anchor
                      key={e.slug + 'mobile'}
                      onClick={() =>
                        this.handleSelection(e.slug, e.displayName)
                      }
                    >
                      <CheckBoxDiv>
                        {selectedType === e.slug ? <TickIcon mobile /> : ' '}
                      </CheckBoxDiv>
                      <Text
                        size="medium"
                        weight={selectedType === e.slug ? 'bold' : 'normal'}
                      >
                        {e.displayName}
                      </Text>
                    </Anchor>
                  ))}
                </ListContainerMobile>
              </Popup>
            )}
          </MobileSort>
        </Media>
        <Media query={SCREEN_SIZE.Only.Tablet}>
          <TabletSort>
            <TinyPopover
              containerClassName={'sort-popover'}
              isOpen={isVisiblePopover}
              position={['bottom']}
              onClickOutside={closePopover}
              content={
                <StyledPopover fade slide expand hideOnClickOutside gutter={4}>
                  <StyledButton>
                    <ListContainer>
                      {data.map(e => (
                        <Anchor
                          key={e.slug + 'tablet'}
                          onClick={() => this.handleSelection(e.slug)}
                        >
                          <CheckBoxDiv>
                            {selectedType === e.slug ? <TickIcon /> : ' '}
                          </CheckBoxDiv>
                          <Text
                            size="medium"
                            weight={selectedType === e.slug ? 'bold' : 'normal'}
                          >
                            {e.displayName}
                          </Text>
                        </Anchor>
                      ))}
                    </ListContainer>
                  </StyledButton>
                </StyledPopover>
              }
            >
              <InlineBlock>
                <ButtonFullWidth onClick={openPopover}>
                  <SortContent
                    isSort={isSortingEnabled}
                    data-testid="expandSortTablet"
                  >
                    <Block>
                      <StyledSort
                        color={
                          isSortingEnabled
                            ? '#1454B8'
                            : defaultTheme.ColorBaseMineShaft700
                        }
                      />
                    </Block>
                    <Block>
                      <SelectedFilter>
                        <Text
                          size="medium"
                          color={
                            isSortingEnabled
                              ? '#1454B8'
                              : defaultTheme.ColorBaseMineShaft700
                          }
                          weight="bold"
                        >
                          {isSortingEnabled
                            ? data.filter(elm => elm.slug === selectedType)[0]
                                .displayName
                            : 'Sort'}
                        </Text>
                      </SelectedFilter>
                    </Block>
                  </SortContent>
                </ButtonFullWidth>
              </InlineBlock>
            </TinyPopover>
          </TabletSort>
        </Media>
        <Media query={SCREEN_SIZE.From.Desktop}>
          <DesktopSort>
            <SortContainer
              onClick={() =>
                this.setState(prevState => ({
                  dropdownOpen: !prevState.dropdownOpen,
                }))
              }
              key="desktop-sort-container"
              data-testid="expand-sort-button"
            >
              <Block>
                <Heading>
                  <Text
                    size="small"
                    weight="black"
                    color={defaultTheme.ColorBaseMineShaft500}
                  >
                    SORT BY
                  </Text>
                </Heading>
                <SelectedFilter>
                  <Text
                    size="medium"
                    color={defaultTheme.ColorBaseMineShaft700}
                  >
                    {
                      data.filter(elm => elm.slug === selectedType)[0]
                        .displayName
                    }
                  </Text>
                </SelectedFilter>
              </Block>
              <Block>
                <ExpandStyled
                  rotated={this.state.dropdownOpen}
                  color={defaultTheme.ColorBaseBrandPrimary500}
                />
              </Block>
            </SortContainer>
            {this.state.dropdownOpen && (
              <ListContainerDesktop>
                {data.map(e => (
                  <Anchor
                    key={e.slug + 'desktop'}
                    onClick={() => this.handleSelection(e.slug, e.displayName)}
                    data-testid="sort-option"
                  >
                    <CheckBoxDiv>
                      {selectedType === e.slug ? <TickIcon /> : ' '}
                    </CheckBoxDiv>
                    <Text
                      size="medium"
                      weight={selectedType === e.slug ? 'bold' : 'normal'}
                    >
                      {e.displayName}
                    </Text>
                  </Anchor>
                ))}
              </ListContainerDesktop>
            )}
          </DesktopSort>
        </Media>
      </PlainContainer>
    )
  }
}

export default withRouter(Sort)
